export default "__VITE_ASSET__BQa9TA68__"